import Image from "next/image";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { TLink } from "@/components/molecules/Button";
import { useBudouX } from "@/hooks/useBudouX";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { VoiceCover } from "@/components/organisms/VoiceCover";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import voicePhoto from "/public/voice-photo7.webp";

export default function CareerArticle7(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "Voices:メンバーの声 No.7 『プロジェクトを振り返って』PMたちの声"
        }
        pageDescription={
          "株式会社トッカシステムズのVoices:メンバーの声 No.7 『プロジェクトを振り返って』PMたちの声。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/voice/7"}
      />
      <Layout className="relative">
        <div className="absolute z-0 aspect-1/1 w-full bg-voices-no7 xs:max-h-[300px] sm:max-h-[300px] md:aspect-1/1 md:max-h-[500px] lg:max-h-[640px]"></div>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                  path: "/",
                },
                {
                  name: "Voices:メンバーの声 No.7",
                },
              ]}
            />
            <Inner className="max-w-full">
              <div className="mx-auto flex max-w-6xl flex-col">
                <VoiceCover
                  title="『プロジェクトを振り返って』PMたちの声"
                  avatar="A: 2018年入社／B：2016年入社／C 2014年入社／D：2020年入社"
                />
                <figure className="relative mt-6 block aspect-21/9 w-full group-hover:opacity-80 md:mt-8 lg:mt-10">
                  <Image
                    src={voicePhoto}
                    alt="『プロジェクトを振り返って』PMたちの声 A: 2018年入社／B：2016年入社／C 2014年入社／D：2020年入社"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </div>
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>
                  ToccaSystemsに入った時の印象を教えてください。
                </Interviewer>
                <Interviewee speaker="B">
                  親しみやすい人が多いです！技術的にわからないことがあっても、質問したら教えてくれるし、困ったことがあれば、すぐにフォローしてくれます。
                </Interviewee>
                <Interviewee speaker="A">
                  クライアントからのヒアリング、要件提議や運用保守まで、一貫して行えるのは、ToccaSystemsの強みだと思います。　
                </Interviewee>
                <Interviewee speaker="D">そうそう。</Interviewee>
                <Interviewee speaker="B">
                  代表取締役もエンジニアなので、現場の話を相談できることも大きいです。業務を理解してもらえるので話しやすいです。距離がとても近い環境なので、気軽に話しかけやすいんですよ。それってもしかしたら他社さんでは、難しいことかもしれません。
                </Interviewee>
                <Interviewer> 立地も良いですよね。</Interviewer>
                <Interviewee speaker="B">
                  そうですね。最寄り駅が神保町なので、アクセスが容易で打ち合わせに行く時もスムーズです。
                </Interviewee>
                <Interviewer>
                  マネージャーは具体的にどんなことをされているんですか？
                </Interviewer>
                <Interviewee speaker="C">
                  毎日の朝回の実施、プロジェクトメンバーとのミーティングですね。メンバーとは個別ミーティングも行って、都度業務目標や進捗状況などを確認してプロジェクトを進行しています。
                </Interviewee>
                <Interviewer>
                  マネージャー業務での嬉しいことや楽しいことってどんなことですか？
                </Interviewer>
                <Interviewee speaker="B">
                  メンバーの成長具合がみれるのは嬉しいですね。
                </Interviewee>
                <Interviewee speaker="A">
                  わかります。喜びですよね。
                </Interviewee>
                <Interviewee speaker="C">
                  プロジェクトがスケジュール通りに進行して、キレイにクローズできると気持ちが上がります。クライアントから喜ばれるのも嬉しいです。
                </Interviewee>
                <Interviewee speaker="D">
                  たしかに！私もやりがいに感じます。
                </Interviewee>
                <Interviewer>
                  プロジェクトが思い通りに進まない時もあると思うのですが、そういう時はどうしていますか？
                </Interviewer>
                <Interviewee speaker="B">
                  ざっくばらんに話してもいいですか（笑）？取締役達を捕まえて飲みに行きます。そこで話を聞いてもらったり…代表取締役がエンジニアなので、話を理解してもらいやすいんですよね。
                </Interviewee>
                <Interviewer> すごくいいですね。</Interviewer>
                <Interviewee speaker="B">
                  的確なアドバイスを貰えますし、業務の調整もお願いできますからね。
                </Interviewee>
                <Interviewee speaker="A">
                  私は、その都度改善してもうまく進まない時は…開き直る！最近そうなってきました。
                </Interviewee>
                <Interviewee speaker="D">
                  解決策を模索して、改善できるところを調整していきますね。
                  その時は、メンバーや取締役達に相談して突破口を見つけます。直面した問題に立ち向かうタイプなので…。
                </Interviewee>
                <Interviewee speaker="C">
                  メンバーにはしっかり話しますね。チームですからみんなで乗り越えないと。締切が差し迫って、本当に大変な時は取締役にも相談し、リカバリー策を検討してもらいます。
                </Interviewee>
                <Interviewer>相談できる環境がたくさんあるんですね</Interviewer>
                <Interviewee speaker="B">
                  週１で行う社内ミーティングでも相談できますしね。話をしやすいタイミングはたくさんありますね。直面している問題があれば、その場で改善できるよう話し合います。ご飯を食べに行ったりして相談するときもあります。
                </Interviewee>
                <Interviewer>今後挑戦したいことはありますか？</Interviewer>
                <Interviewee speaker="B">
                  現在、管理と作業の両方を行っているので、今後はメンバーに作業をお願いして、自分はしっかりとマネジメントできるような体制づくりに注力して、プロジェクトを円滑に回せるようにしたいです。しかし、まずは成果物の精度を上げるのが第一だと思っています。
                </Interviewee>
                <Interviewee speaker="A">
                  プロジェクトの基盤となるモデルプロジェクトを作って展開していきたいと考えています。
                </Interviewee>
                <Interviewee speaker="D">
                  自分がまだ持っていない技術を習得したり、弱い技術を伸ばしていきたいですね。マネージャーとしては、育成の知識が足りないと思うので、セミナー等に率先して参加しようと計画しています。
                </Interviewee>
                <Interviewee speaker="C">
                  ToccaSystemsとして、取り組んでいない領域にチャレンジしたい。
                </Interviewee>
                <Interviewee speaker="D">
                  フルスタックエンジニアになりたいです。そんな人がいるかわからないけれど…せっかくシステム業界にいるので、そこを目指していきたいです。
                </Interviewee>
                <Interviewer>
                  一緒に働いてみたいと思うのはどんな人ですか？どんな人に入社してもらいたいですか？
                </Interviewer>
                <Interviewee speaker="D">
                  積極的にコミュニケーションをとる人、やる気がある人と一緒に働きたいですね。あと調べる能力って大事だと思うので、何でも積極的に調べる人は合うんじゃないかなぁ。
                </Interviewee>
                <Interviewee speaker="C">
                  入社してから学ぶことってたくさんあると思うんです。学んだことをしっかり吸収して、身につけられる人は良いなと思います。
                </Interviewee>
                <Interviewee speaker="A">
                  プログラムを書く場合でも、どうしたら使いやすいかを考えることができる人や、クライアントや、プロジェクトを共に進めるメンバーのことを気遣いながら仕事を進めることができる、思いやりのある人が良いですね。
                </Interviewee>
                <Interviewer>技術よりも『人となり』なんですね。</Interviewer>
                <Interviewee speaker="B">
                  私は未経験で入社したので、特にそう思います。技術は入社後でも身につけられますしね。
                </Interviewee>
                <div className="flex justify-end px-8 md:px-0">
                  <TLink href="/careers/" variant="mono" color="ff">
                    Carrers top
                  </TLink>
                </div>
              </div>
              <VoiceNav />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
